module.exports = __webpack_public_path__ + "img/talking.10645721.svg";